module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAcCAYAAAB75n/uAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAZdEVYdFNvZnR3YXJlAHBhaW50Lm5ldCA0LjAuMjHxIGmVAAAArUlEQVRIS+2Q0Q2DMAwFs04HYATURRigq3QNRmAQ1nF5SFFN9JLG2HyVJ92Pke5QkogcGB8veT8ljEvloCr37hBgf+5d9lSfxbvsSVqq8S57zAH2vXW7A/tatz8M9C57Lgmsy9cTHtDyaZhjA6V8WwoLMDmoBkr0tKxEy4E5YJEDU8AqB92BM3LQHajRkgNX4Jcc0CM4I2PQI4iQA3oEEXJAjyBCDugRRMhFJH0AmmN1fa//AlsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/glitch-twitch.png
// module id = 178
// module chunks = 0